<template>
    <div class="IndexBox">
      <div class="ScrollBox">
        <van-nav-bar
          fixed
          :border="false"
          :title="$t('user.office[2]')"
          left-arrow
          @click-left="$router.go(-1)"
        />
        <!-- 优先按图片方式自适应展示（针对仅返回 <p><img .../></p> 的场景） -->
        <div v-if="imageUrl" class="img-wrapper">
          <img :src="imageUrl" alt="position-intro" class="intro-img" />
        </div>
        <!-- 如后端未来返回图文混排，这里依然可以降级渲染原始 HTML -->
        <div v-else class="awards-content" v-html="awardsContent"></div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'PostionIntro',
    data () {
      return {
        awardsContent: '',
        staticBasePath: ''
      }
    },
    computed: {
      // 从后端返回的 HTML 中解析第一张图片地址
      imageUrl () {
        if (!this.awardsContent) return ''
        const match = this.awardsContent.match(/<img[^>]+src=["']([^"']+)["']/i)
        return match ? match[1] : ''
      }
    },
    created () {
      // 计算静态资源前缀，兼容根路径 / 与 /sgm 等二级目录
      if (typeof window !== 'undefined') {
        const path = window.location.pathname || '/'
        const segments = path.split('/').filter(Boolean)
        const firstSegment = segments.length > 0 ? `/${segments[0]}` : ''
        this.staticBasePath = firstSegment
      } else {
        this.staticBasePath = ''
      }
  
      this.$parent && (this.$parent.navBarTitle = this.$t('user.office[2]'))
      this.loadInitData()
    },
    methods: {
      // 统一拼接静态资源路径
      withStaticBase (relativePath) {
        const p = String(relativePath || '').replace(/^\/+/, '')
        return `${this.staticBasePath}/${p}`
      },
      // 读取缓存中的职位描述内容（与 apply.vue 保持一致逻辑）
      loadInitData () {
        try {
          const s = localStorage.getItem('InitData')
          if (s) {
            const init = JSON.parse(s)
            if (init && init.info && init.info.position && init.info.position.content) {
              this.awardsContent = init.info.position.content || ''
              return
            }
          }
        } catch (e) {
          // ignore
        }
        if (this.$Model && typeof this.$Model.GetBackData === 'function') {
          this.$Model.GetBackData((info) => {
            if (info) {
              try { localStorage.setItem('InitData', JSON.stringify(info)) } catch (e) {}
              if (info.position && info.position.content) {
                this.awardsContent = info.position.content || ''
              }
            }
          })
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .IndexBox {
    min-height: 100vh;
    padding-bottom:0;
  }
  
  .img-wrapper {
    padding-top: 56px; /* 给导航栏留出空间 */
  }
  
  .intro-img {
    display: block;
    width: 100%;
    height: auto;
  }
  
  .awards-content {
    padding: 56px 0 12px;
    box-sizing: border-box;
  }
  </style>  